const $ = jQuery.noConflict();

export default function scrollCheck() {
    function scrollCheckInit() {
        if ($(window).scrollTop() > 0) {
            $("body").addClass("scrolled");
        } else {
            $("body").removeClass("scrolled");
        }
    }

    $(window).scroll(function onScroll() {
        scrollCheckInit();
    });
}
